import { Instance } from 'mobx-state-tree'
import { QuestionType } from '../models/QuestionType'

export const isQuestionType = (value: string): value is Instance<typeof QuestionType> => {
  const types = [
    'Multiple Choice',
    'Multiple Response',
    'True or False',
    'Card',
    'Matching',
    'Ordering',
    'Open Text',
  ]
  return types.includes(value)
}
